import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
// import FavoriteIcon from '@material-ui/icons/Favorite';

import React, { useState, useEffect } from 'react';

const MESSAGES = [
  // {
  //   text: '¡$150 en tu primera compra! Código: HOLAGLOSET',
  //   link: 'https://gloset.mx/s?hotlist=true'
  // },
  {
    text: '¡Pon en venta 5 prendas y gana $500! 💸✨',
    link: 'https://gloset.notion.site/Vende-5-cosas-y-gana-2-000-209b7dd0310b80569ca7f2988b464d67'
  },
  {
    text:'$150 EN TU PRIMERA COMPRA, CÓDIGO: HOLAGLOSET ✨',
    link: 'https://gloset.mx/s?hotlist=true'
  }
];

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    textAlign: 'center',
    color: '#000000',
    background: '#FFD4DD',
    fontFamily: 'CircularStd, Kenac, Arial, sans-serif !important',
    fontSize: '16px',
    minHeight: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '12px 0',
    cursor: 'pointer',
    transition: 'opacity 0.3s ease',
    '&:hover': {
      opacity: 0.9,
    }
  },
  link: {
    textDecoration: 'none !important',
    color: 'inherit !important',
    width: '100%',
    display: 'block',
    '&:hover': {
      textDecoration: 'none !important',
      color: 'inherit !important',
    },
    '&:visited': {
      color: 'inherit !important',
    },
    '&:active': {
      color: 'inherit !important',
    }
  },
  icon: {
    verticalAlign: 'middle',
    marginLeft: '4px',
    fontSize: '20px'
  }
}));

const ShippingBanner = () => {
  const classes = useStyles();
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % MESSAGES.length);
    }, 7000);

    return () => clearInterval(timer);
  }, []);

  const currentMessage = MESSAGES[currentIndex];

  return (
    <div className={classes.root}>
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <a href={currentMessage.link} className={classes.link}>
            <Paper className={classes.paper}> 
              {currentMessage.text}
            </Paper> 
          </a>
        </Grid>
      </Grid>
    </div>
  );
};

export default ShippingBanner;
